import { render, staticRenderFns } from "./datatablesimple.vue?vue&type=template&id=07e6ea4b&scoped=true&"
import script from "./datatablesimple.vue?vue&type=script&lang=js&"
export * from "./datatablesimple.vue?vue&type=script&lang=js&"
import style0 from "./datatablesimple.vue?vue&type=style&index=0&id=07e6ea4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e6ea4b",
  null
  
)

export default component.exports